import { format } from '@tusbar/cache-control';
import { Duration } from '@boc/duration';

export const NoCache = format({
  maxAge: 0,
  sharedMaxAge: 0,
  noCache: true,
  noStore: true,
  private: true,
  public: false,
  mustRevalidate: true,
  proxyRevalidate: true,
});

export const CacheControlNoCache = {
  'Cache-Control': NoCache,
};

export const CacheControlOneHour = {
  'Cache-Control': format({
    maxAge: 60 * 60,
    sharedMaxAge: 60 * 60,
    noCache: false,
    noStore: false,
    private: false,
    public: true,
    mustRevalidate: false,
    proxyRevalidate: false,
  }),
};

export const CacheControlOneDay = {
  'Cache-Control': format({
    maxAge: 60 * 60 * 24,
    sharedMaxAge: 60 * 60 * 24,
    noCache: false,
    noStore: false,
    private: false,
    public: true,
    mustRevalidate: false,
    proxyRevalidate: false,
  }),
};

export const CacheControlOneWeek = {
  'Cache-Control': format({
    maxAge: 60 * 60 * 24 * 7,
    sharedMaxAge: 60 * 60 * 24 * 7,
    noCache: false,
    noStore: false,
    private: false,
    public: true,
    mustRevalidate: false,
    proxyRevalidate: false,
  }),
};

export const CacheControlOneMonth = {
  'Cache-Control': format({
    maxAge: 60 * 60 * 24 * 30,
    sharedMaxAge: 60 * 60 * 24 * 30,
    noCache: false,
    noStore: false,
    private: false,
    public: true,
    mustRevalidate: false,
    proxyRevalidate: false,
  }),
};

export const generateCacheControl = ({
  maxAge,
  sharedMaxAge,
}: {
  maxAge?: number;
  sharedMaxAge?: number;
}) => {
  return format({
    maxAge,
    sharedMaxAge,
    noCache: false,
    noStore: false,
    private: false,
    public: true,
    mustRevalidate: false,
    proxyRevalidate: false,
  });
};

/**
 * Generate Cache-Control header with Duration objects
 * @param maxAge - Browser cache duration as Duration object
 * @param sharedMaxAge - CDN/proxy cache duration as Duration object
 */
export const generateCacheControlV2 = ({
  maxAge,
  sharedMaxAge,
}: {
  maxAge?: Duration;
  sharedMaxAge?: Duration;
}) => {
  return generateCacheControl({
    maxAge: maxAge?.seconds,
    sharedMaxAge: sharedMaxAge?.seconds,
  });
};
